export default __webpack_public_path__ + "static/media/unlink.c9e6f07d.svg";